import { api } from "./client.js";

export interface ConnPerson {
  id: string;
  name: string;
  handle: string | null;
  status?: string;
  requested_at?: string | null;
}

export const connectionsApi = {
  list: () => api.get<{ connections: ConnPerson[] }>("/api/connections"),
  requests: () => api.get<{ requests: ConnPerson[] }>("/api/connections/requests"),
  request: (userId: string) =>
    api.post<{ status: string }>("/api/connections/requests", { userId }),
  accept: (userId: string) => api.post<{ status: string }>(`/api/connections/${userId}/accept`),
  decline: (userId: string) => api.post<{ status: string }>(`/api/connections/${userId}/decline`),
  block: (userId: string) => api.post<{ status: string }>(`/api/connections/${userId}/block`),
  disconnect: (userId: string) => api.del<{ status: string }>(`/api/connections/${userId}`),
};
